import './StorySection.css'

const StorySection = () => {
  return (
    <section className="story-section" id="story">
      <div className="container">
        <div className="story-layout">
          <article className="story-poster">
            <div className="story-copy">
              <span>Calidad premium</span>
              <h3>¿Te vas a perder esta bomba?</h3>
              <p>
                En Mister tenemos opciones para todos los antojos:
                burgers, lomos, wraps y ensaladas preparadas al momento.
              </p>
            </div>
            <img
              className="story-image"
              src="/images/historia.jpg"
              alt="Interior de Mister Burger"
              loading="lazy"
            />
          </article>

          <div className="story-cards" aria-label="Diferenciales de Mister Burger">
            <article className="story-card dark">
              <span>Calidad</span>
              <strong>Ingredientes frescos</strong>
            </article>
            <article className="story-card yellow">
              <span>Elegí</span>
              <strong>Tu opción preferida</strong>
            </article>
            <article className="story-card">
              <span>Cocina</span>
              <strong>Preparado al momento</strong>
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}

export default StorySection
